function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m36.7826 26.1499 1.6435-10.8626c.5478-3.0273-.3652-6.2327-2.5565-8.54769-2.0087-2.315-5.1131-3.73961-8.4-3.73961h-7.3044c-3.2869 0-6.2087 1.42461-8.4 3.73961-1.82607 2.31499-2.73912 5.52039-2.19129 8.54769l1.64349 10.8626",
  stroke: "#c5cad1",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m13.0435 43.2192v1.7808",
  stroke: "#ffd200",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m34.9565 43.2192v1.7808",
  stroke: "#ffd200",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m41.3478 24.3692c-3.4695 0-6.3913 2.8492-6.3913 6.2327v2.6711s-2.7391-1.7808-10.9565-1.7808-10.9565 1.7808-10.9565 1.7808v-2.6711c0-3.3835-2.9218-6.2327-6.39133-6.2327-2.00869 0-3.65217 1.6027-3.65217 3.5615 0 1.4246.91304 2.6712 2.1913 3.2054.91305.3561 1.46087 1.0684 1.46087 2.1369v3.5615c0 3.0273 2.37392 5.3423 5.47823 5.3423h23.7392c3.1043 0 5.4782-2.315 5.4782-5.3423v-3.5615c0-.8904.5479-1.7808 1.4609-2.1369 1.2783-.5342 2.1913-1.7808 2.1913-3.2054 0-1.9588-1.6435-3.5615-3.6522-3.5615z",
  stroke: "#c5cad1"
})), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m31 19-2-2.5 2-2.5",
  stroke: "#c5cad1",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m17 19 2-2.5-2-2.5",
  stroke: "#c5cad1",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m24 20c2.2091 0 4-1.567 4-3.5s-1.7909-3.5-4-3.5-4 1.567-4 3.5 1.7909 3.5 4 3.5z",
  stroke: "#ffd200",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgFurniture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture);
export default __webpack_public_path__ + "static/media/furniture.7a93553b.svg";
export { ForwardRef as ReactComponent };